<template>
  <div class="start">
    <img :src="bgUrl" class="back" height="100%" width="100%" />
    <div class="title">
      <p class="title-p">{{ topTitle }}</p>
    </div>
    <div class="start-button">
      <button @click="goQuestion" class="satrt-button__question">Start Quiz</button>
    </div>
  </div>
</template>

<script>
/* global gtag */
export default {
  name: 'start',
  data () {
    return {
      bgUrl: 'https://static.picku.cloud/imageView2/cloud/b9cfb140/christmas-2020/start_pic.png',
      topTitle: 'Take a photo with your Santa'
    }
  },
  mounted () {
    if (this.$device === 'IOS') {
      this.topTitle = 'Pick up your Santa'
    } else {
      this.topTitle = 'Take a photo with your customized “Santa”'
    }
    gtag('event', 'Xmas_home_page_show')
  },
  methods: {
    goQuestion () {
      console.log(gtag)
      gtag('event', 'Xmas_home_start_btn_click')
      this.$router.push({ name: 'question', params: { isStartIn: true } })
    }
  }
}
</script>

<style lang='less'>
.start {
  width: 100%;
  height: 100%;
  .back {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: -1;
    // height: 100%;
  }
  .title {
    position: absolute;
    top: 26%;
    width: 100%;
    text-align: center;
    .title-p {
      font-size: 1.47rem;
      width: 8.53rem;
      line-height: 1.70rem;
      margin: 0 auto;
      font-weight: bold;
      color: #ffffff;
      text-shadow: 2px 2px 4px rgba(111, 29, 76, 0.6);
    }
  }
  .start-button {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 2rem;
    .satrt-button__question {
      border: none;
      width: 12.6rem;
      height: 2.8rem;
      background: rgba(255, 255, 255, 0.05);
      box-shadow: 0px 0.1rem 0.6rem 0px rgba(37, 4, 50, 0.33),
       inset 0px 0.1rem 1rem 0px rgba(255, 255, 255, 0.2), inset 0.1rem 0.1rem 0.3rem 0.1rem #ffffff;
      border-radius: 2.8rem;
      font-size: 1rem;
      font-weight: bold;
      color: #fff;
      line-height: 1rem;
      animation: button__question 1.5s linear 1s infinite;
      @keyframes button__question {
        0% {
                -webkit-transform: scale(1);
                transform: scale(1)
            }
          25% {
                -webkit-transform: scale(1.1);
                transform: scale(1.1)
            }
            50% {
                -webkit-transform: scale(1);
                transform: scale(1)
            }
            75% {
                -webkit-transform: scale(0.9);
                transform: scale(0.9)
            }
            100% {
                -webkit-transform: scale(1);
                transform: scale(1)
            }
      }
    }
  }
}
</style>
